import type { Locale } from '../constants'
import { bn } from './bn'
import { type Dictionary, en } from './en'

export type { Dictionary }
export { bn, en }

export const dictionaries: Record<Locale, Dictionary> = { en, bn }

export function getDictionary(locale: Locale): Dictionary {
  return dictionaries[locale] ?? en
}

/** Fills `{name}` placeholders. Missing values are left visible, not silently blanked. */
export function interpolate(
  template: string,
  values: Record<string, string | number> = {},
): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match,
  )
}

/**
 * Minimal translator: `t('kiosk.startOrder')`.
 * Deliberately dependency-free — this runs in Workers, Astro and React alike.
 */
export function createTranslator(locale: Locale) {
  const dictionary = getDictionary(locale)

  return function t(path: string, values?: Record<string, string | number>): string {
    const resolved = path
      .split('.')
      .reduce<unknown>(
        (node, key) =>
          node && typeof node === 'object' ? (node as Record<string, unknown>)[key] : undefined,
        dictionary,
      )

    if (typeof resolved !== 'string') return path
    return values ? interpolate(resolved, values) : resolved
  }
}

export type Translator = ReturnType<typeof createTranslator>
